var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseTemplate',{attrs:{"currentUser":_vm.currentUser}},[_c('div',{staticClass:"contact-list"},[_c('Title',{attrs:{"jpn":_vm.t('Contact us')}}),_vm._v(" "+_vm._s(_vm.dispContactList)+" ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }